var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.menu.menu_items)?_c('div',[(_vm.showMobile)?_c('mobile-navigation',{attrs:{"menu":_vm.menu,"can-access-golf":_vm.canAccessGolf}}):_c('desktop-navigation',{attrs:{"menu":_vm.menu,"can-access-golf":_vm.canAccessGolf}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }